<style src="./ResponseItems.scss" lang="scss"></style>
<template>
  <li class="itemrow">
    <ul class="itemcontainer">
      <li class="column-item box">
        <div class="notquote">
          <span
            v-if="!!form.notQuote"
            class="title">
            NÃO COTADO
          </span>
        </div>

        <div class="id">
          <span
            v-if="!!item.itemInfo.lot"
            class="labellot">{{ item.itemInfo.lot }}</span>
          <span class="labelitem">{{ item.itemInfo.number }}</span>
        </div>

        <div class="description">
          <div class="counts">
            <span title="Quantidade">{{ item.itemInfo.quantity | DecimalNumber }}</strong></span>
            <span title="Fator" v-show="Number(item.itemInfo.factor) > 0"><small>X</small> <strong>{{ item.itemInfo.factor | DecimalNumber }}</strong></span>
            <span title="Preço estimao"><small>R$</small> <strong>{{ item.itemInfo.estimatedPrice | CurrencyBR }}</strong></span>
            <span title="Total" class="total"><small>R$</small> <strong>{{ (item.itemInfo.estimatedPrice || 0) * (item.itemInfo.quantity || 1)  | CurrencyBR('SEM EST') }}</strong></span>
            <span title="Unidade"><strong>{{ item.itemInfo.unity }}</strong></span>
          </div>
          <span class="description">{{ item.itemInfo.description }}</span>
        </div>

        <div class="product">
          <div
            class="notquoted"
            v-if="!(item.itemQuoted && item.itemQuoted.pativo)">
            <span class="label">NÃO COTADO</span>
          </div>

          <template v-if="item.itemQuoted && item.itemQuoted.pativo">
            <cp1-suggest-product
              placeholder="Nome do produto"
              @selected="selectedProduct"
              v-model="form.product"/>
            
            <form
              @submit.prevent
              class="commands">
              <label class="checkbox-label">
                <input
                  class="checkbox-input"
                  type="checkbox"
                  v-model="form.isPriceGuaranted">
                <span class="label">Garante Preço</span>
              </label>

              <!-- COST -->
              <div class="values">
                <div
                  class="rowblock"
                  :class="{ 'invalid': costHigherThanMax }">
                  <span class="label">Custo R$</span>
                  <moneybox-small
                    class="inputvalue"
                    placeholder="0,50"
                    v-model="form.price"
                    :precision="4" />     
                </div>

                <div class="rowblock">
                  <span class="label total">Total R$</span>
                  <span class="inputvalue total">{{ calculatedTotal | CurrencyBR('0,00') }}</span>   
                </div>
              </div>

              <!-- MAX PRICE -->
              <div class="values max">
                <div class="rowblock" :title="form.maxOrigin">
                  <span class="label">Máx R$</span>
                  <span class="inputvalue total">
                    {{ maxPrice | CurrencyBR('0,00', 4) }}
                    <span
                      title="Margem do preço máximo em cima do custo"
                      class="profit"
                      :class="{ 'negativeprofit': profitMaring < 0 }">{{ profitMaring | DecimalNumber('0', 0)}}%</span>
                  </span>   
                </div>

                <div class="rowblock">
                  <span class="label total"><strong>Total R$</strong></span>
                  <span class="inputvalue total"><strong>{{ maxCalculatedTotal | CurrencyBR('0,00') }}</strong></span>   
                </div>
              </div>
              
              <div class="buttons">
                <button
                  class="btn-primary btnsave"
                  label="Salvar Cotação"
                  @click="saveItem">
                  <icon-save class="icon" />
                  Salvar
                </button>

                <button
                  class="btn-ghost btnnoquote"
                  label="Salvar Cotação"
                  @click="noQuoteItem">
                  <icon-close class="icon" />
                  Não cotar
                </button>
              </div>
            </form>
          </template>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
import { Moneybox, MoneyboxSmall, ButtonSubmit, Cp1SuggestProduct } from '@/components/primitives'
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconWait, IconSave, IconClose } from '@/components/primitives/icons'

export default {
  name: 'ResponseItems',
  components: {
    Cp1SuggestProduct,
    ButtonSubmit,
    Moneybox,
    MoneyboxSmall,
    IconWait,
    IconSave,
    IconClose
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    supplierId: {
      default: null
    }
  },
  data () {
    return {
      form: {
        product: null,
        productId: null,
        productLab: null,
        price: 0,
        isPriceGuaranted: false,
        notQuote: false,
        cmedPrice: 0,
        maxOrigin: 'Não definida'
      },
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      },
      precision: 4
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    calculatedTotal () {
      const total = this.convertToCurrency(this.form.price) * this.item.itemInfo.quantity
      return total
    },
    maxPrice () {
      if ((this.form.cmedPrice || this.item.itemInfo.estimatedPrice + 1) > (this.item.itemInfo.estimatedPrice || 0)) {
        this.form.maxOrigin = `Máximo: ESTIMADO. cmed cotado a R$ ${CurrencyBR(this.form.cmedPrice, '0,00')}`
        return this.item.itemInfo.estimatedPrice
      } else {
        this.form.maxOrigin = `Máximo: CMED. estimado cotado a R$ ${CurrencyBR(this.item.itemInfo.estimatedPrice, '0,00')}`
        return this.form.cmedPrice
      }
    },
    maxCalculatedTotal () {
      return this.maxPrice && this.maxPrice * this.item.itemInfo.quantity
    },
    profitMaring () {
      return ((this.maxPrice * 100) / this.convertToCurrency(this.form.price)) - 100
    },
    costHigherThanMax () {
      if (this.maxPrice > 0) {
        return this.convertToCurrency(this.form.price) > this.maxPrice
      }

      return false
    },
    isHigherThanEstimated () {
      return this.item.itemInfo.estimatedPrice &&
        this.item.itemInfo.estimatedPrice > 0 &&
        this.convertToCurrency(this.form.price) > this.item.itemInfo.estimatedPrice
    }
  },
  watch: {
    item: {
      handler (v) {
        if (v.suppliersQuote && v.suppliersQuote.quotations) {
          const quoteInfo = v.suppliersQuote.quotations.find(i => i.supplier.toString() === this.supplierId)

          if (quoteInfo) {
            const price = quoteInfo.price || 0

            const priceFlat = price
              .toFixed(this.precision)
              .toString()
              .replace('.', '')
              .replace(',', '')

            const priceNoZero = Number(priceFlat)
              .toString()

            this.form.notQuote = quoteInfo.notQuote
            this.form.price = priceNoZero
            this.form.productId = quoteInfo.item || null
            this.form.product = quoteInfo.comercialName && `${quoteInfo.comercialName} - ${quoteInfo.lab}`
            this.form.productLab = quoteInfo.lab
            this.form.cmedPrice = quoteInfo.cmedPrice || 0
            this.form.isPriceGuaranted = quoteInfo.isPriceGuaranted || false
          } else {
            this.form.notQuote = false
            this.form.price = 0
            this.form.productId = null
            this.form.product = ''
            this.form.cmedPrice = 0
            this.form.isPriceGuaranted = false
            this.form.productLab = null
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    selectedProduct (pProduct) {
      this.form.cmedPrice = pProduct.source && pProduct.source.lookupCmed && pProduct.source.lookupCmed.computedValue
      this.form.productId = pProduct.source._id
      this.form.productLab = pProduct.source.lab
    },
    async saveItem () {
      const quoteInfo = this.prepareQuoteInfo()
      quoteInfo.isChoice = false
      quoteInfo.noQuote = false

      try {
        await this.$store.dispatch('Quote/SAVE_QUOTATION_RESPONSE', quoteInfo)
        this.$store.commit('Quote/UPDATE_QUOTATION_RESPONSE_ITEM', {
          supplierId: this.supplierId,
          quoteId: quoteInfo.quoteId,
          productName: this.form.product,
          productLab: this.form.productLab,
          productId: this.form.productId,
          isPriceGuaranted: this.form.isPriceGuaranted,
          cmedPrice: this.form.cmedPrice,
          notQuote: this.form.notQuote,
          price: this.form.price
        })
        this.$toasted.success('Resultado salvo')
        this.$emit('saved-item')
      } catch (error) {
        console.error(error)
        this.$toasted.error('O item não pode ser salvo')
      }
    },
    async noQuoteItem () {
      const quoteInfo = this.prepareQuoteInfo()
      quoteInfo.isChoice = false
      quoteInfo.noQuote = true

      await this.$store.dispatch('Quote/SAVE_QUOTATION_RESPONSE', quoteInfo)

      // const eventId = this.$route.params.id
      // await this.$store.dispatch('Quote/LOAD_EVENT_LIST', { eventId })

      this.form.notQuote = true

      this.$toasted.success('Modificação salva')
    },
    prepareQuoteInfo () {
      const quoteSupplier = this.item.suppliersQuote.quotations.find(i => i.supplier.toString() === this.supplierId.toString())
      const receiveDate = new Date()
      const quoteId = this.item._id
      const quoteInfo = {
        quoteId,
        quoteSupplierId: quoteSupplier._id,
        supplierId: this.supplierId,
        productId: this.form.productId,
        price: this.form.price.replace('.', '').replace(',', '.'),
        isPriceGuaranted: this.form.isPriceGuaranted,
        receiveDate
      }
      return quoteInfo
    },
    convertToCurrency (v) {
      return Number(v
        .toString()
        .replace('.', '')
        .replace(',', '.'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-quote/components/response-items/ResponseItems.vue